export const getApiErrorMessage = (error, fallback = 'Something went wrong.') => {
  const responseData = error?.response?.data;

  if (responseData?.message) {
    return responseData.message;
  }

  if (Array.isArray(responseData?.details) && responseData.details.length > 0) {
    return responseData.details.map((detail) => `${detail.field}: ${detail.message}`).join(', ');
  }

  return responseData?.error || error?.message || fallback;
};
